import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	monitorOne: 3,
	monitorTwo: 4,
	monitorThree: 5,
	monitorFour: 6,
	monitorFive: 7,
	dialogTwo: 8,
	monitorSix: 9,
	monitorSeven: 10,
	monitorEight: 11,
	monitorNine: 12,
	monitorTen: 13,
	monitorEleven: 14,
	monitorTwelve: 15,
	dialogThree: 16,
	dialogFour: 17,
	win: 18,
}

export const Tema5SubtopicThreeActivityTwo = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema5.activities.subtema3], 1);
	useEffect(() => {
		if (loaded) {
			console.log("tema 5 subtema3 activity 2");
			ObserverEmitter.emit(EVENTS.tema5.subtopicThree.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act2_a01)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema5.subtopicThree.initScene, 2);
						ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's3_m1')
						ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, true)
						ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.21, 2.79)
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Actividad 2: Transacción de remesas." />
					<DialogBarNew
						dialog={
							'Es importante tomar en cuenta lo que vimos previamente para las remesas. Ahora veamos los pasos a seguir para realizar esa transacción, ¡vamos!'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.viewActivities);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 3: Remesas"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act2_a02)
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.moveCameraToMonitor)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's3_m1')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, true)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.21, 2.79)
							setUiToShow(steps.monitorOne);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.monitorOne && (
				<>
					<BarStatusActivies activities={tasksList} />
					<DialogBarNew
						dialog={
							'Primer paso: Para realizar un retiro de dinero se deberá ingresar al menú de cobro de servicios, presionando la tecla “-” o seleccionando el botón de Servicios.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act2_a03)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's3_m2')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, 0.13, 2.73)
							setUiToShow(steps.monitorTwo);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorTwo && (
				<>
					<DialogBarNew
						dialog={
							'Segundo paso: Selecciona la opción de “Envíos de Dinero”.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act2_a04)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's3_m3')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, 0.13, 2.63)
							setUiToShow(steps.monitorThree);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorThree && (
				<>
					<DialogBarNew
						dialog={
							'Tercer paso: Selecciona la opción de “Retiro de dinero”, según la operación que el cliente desee realizar.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act2_a05)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's3_m4')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.06, 2.88)
							setUiToShow(steps.monitorFour);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorFour && (
				<>
					<DialogBarNew
						dialog={
							'Cuarto paso: El cajero se tiene que autenticar antes de proceder con el retiro de dinero. Selecciona el cajero correspondiente y su contraseña.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act2_a06)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's3_m5')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.08, 2.65)
							setUiToShow(steps.monitorFive);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorFive && (
				<>
					<DialogBarNew
						dialog={
							'Quinto paso: El cajero deberá preguntar al cliente antes de continuar con el retiro, si cuenta con los datos requeridos: (Numero de Transferencia, Alguna identificación oficial).'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act2_a07)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
							setUiToShow(steps.dialogTwo);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<DialogBarNew
						dialog={
							"En caso de contar con los datos requeridos se continúa con el retiro, en caso de que no, se cancela y se informa al cliente."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act2_a08)
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.moveCameraToMonitor)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's3_m6')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, 0.15, 2.73)
							setUiToShow(steps.monitorSix);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorSix && (
				<>
					<DialogBarNew
						dialog={
							'Sexto paso: Captura el “Numero de Transferencia”.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act2_a09)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's3_m7')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, 0.02, 2.76)
							setUiToShow(steps.monitorSeven);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorSeven && (
				<>
					<DialogBarNew
						dialog={
							'Séptimo paso: Captura el nombre completo del beneficiario, monto a entregar y captura los datos de identificación.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act2_a10)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.15, 2.87)
							setUiToShow(steps.monitorEight);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorEight && (
				<>
					<DialogBarNew
						dialog={
							'(Las Identificaciones válidas son las siguientes: IFE, Pasaporte, Cartilla, Credencial Consular y Cédula Profesional). Selecciona continuar con el retiro.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act2_a11)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.19, 2.97)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's3_m8')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, false)
							setUiToShow(steps.monitorNine);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorNine && (
				<>
					<DialogBarNew
						dialog={
							'Octavo paso: El cajero deberá validar que el nombre del beneficiario coincida con los datos de la identificación y que sea efectivamente la persona que está haciendo el retiro.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act2_a12)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, true)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.08, 2.78)
							setUiToShow(steps.monitorTen);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorTen && (
				<>
					<DialogBarNew
						dialog={
							'Si los datos son correctos se selecciona “SI”, de lo contrario se cancela la transacción y se le informa al cliente que no coinciden los datos.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act2_a13)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's3_m9')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, false)
							setUiToShow(steps.monitorEleven);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorEleven && (
				<>
					<DialogBarNew
						dialog={
							'Noveno paso: El cajero deberá de capturar todos los datos del Beneficiario.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act2_a14)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's3_m10')
							setUiToShow(steps.monitorTwelve);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorTwelve && (
				<>
					<DialogBarNew
						dialog={
							'Decimo paso: El cajero deberá verificar que el ticket se haya impreso correctamente y entregárselo al cliente.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act2_a15)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={
							'Una vez que se haya impreso el ticket se selecciona la opción “SI” para proceder con la entrega del efectivo.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act2_a16)
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						dialog={
							'Se imprimirán 2 comprobantes: • EL ticket #1 lo deberá firmar el cliente y éste será resguardado por el cajero. • El ticket #2 se le entregará al cliente como comprobante del retiro.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={0}
						dialogModal="¡Increíble! Has dominado completamente el proceso de retiro de remesas."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 0,
									subtema: tasksId.tema5.activities.subtema3,
								})
							);
							navigation("/home5/tema5/subtema3/activityThree");
						}}
					/>
				</>
			)}

		</>

	)
}